import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { ChallanOutModel } from '../model/index';

@Injectable()
export class ChallanOutService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private challanoutUrl = 'api/challanOut';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getChallanoutList(query: any): Promise<ChallanOutModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.challanoutUrl}/getChallanoutList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getChallanOutModelDetails(query: any): Promise<ChallanOutModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.challanoutUrl}/getChallanOutModelDetails`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    addChallanOutModel(query: any): Promise<ChallanOutModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.challanoutUrl}/addChallanOutModel`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    deleteChallanModel(rowData: any): Promise<ChallanOutModel> {
        const url = `${this.challanoutUrl}/deleteChallanModel`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ChallanOutModel)
            .catch(this.handleError);
    }

    // getTestingbill(client_id: number): Promise<ChallanOutModel> {
    //     const url = `${this.challanoutUrl}/clientList?client_id=${client_id}`;
    //     return this.http.get(url)
    //         .toPromise()
    //         .then(response => response.json().data as ChallanOutModel)
    //         .catch(this.handleError);
    // }
    //
    // getTestingbillClientList(): Promise<any> {
    //     const url = `${this.challanoutUrl}/getTestingbillClientList`;
    //     return this.http.get(url)
    //         .toPromise()
    //         .then(this.extractData)
    //         .catch(this.handleError);
    // }
    //
    // getTestingtypeList(): Promise<any> {
    //     const url = `${this.challanoutUrl}/getTestingtypeList`;
    //     return this.http.get(url)
    //         .toPromise()
    //         .then(this.extractData)
    //         .catch(this.handleError);
    // }

    deleteChallanOut(rowData: any): Promise<ChallanOutModel> {
        const url = `${this.challanoutUrl}/deleteChallanOut`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ChallanOutModel)
            .catch(this.handleError);
    }

    addUpdateChallanout(testbilldetail: any): Promise<ChallanOutModel> {

        const url = `${this.challanoutUrl}/addUpdateChallanout`;

        return this.http
            .post(url, $.param(testbilldetail), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ChallanOutModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/challanOut.service.ts